import log from 'salvo-lite/log'
import Choices from 'choices.js'

class CollectionFilter {
    constructor (elem) {
        this._elem = elem
        this._filterData = JSON.parse(document.querySelector('#json-filter-data').innerHTML)

        this._elems = {
            'select': document.querySelectorAll('select'),
            'arrayItem': '',
            'imageWrappers': document.querySelectorAll('.ProductItem__ImageWrapper')
        }

        this._vars = {
            'selectedBrand': '',
            'selectedDevice': '',
            'selectedCollection': '',
            'pageLoadTags': JSON.parse(document.querySelector('[data-section-type="collection"]').dataset.sectionSettings).currentTags,
            'collectionsPath': JSON.parse(document.querySelector('[data-section-type="collection"]').dataset.sectionSettings).collectionUrl + '/',
            'onPageLoaded': false,
            'currentTags': JSON.parse(document.querySelector('[data-current-tags]').innerHTML).currentTags
        }

        this._filters = {
            'brandFilters': document.querySelectorAll('.brand-wrapper label'),
            'deviceFilter': '',
            'collectionFilter': '',
            'sortByFilter': ''
        }

        this._collectionArray = [
            {value: '_collection-all', label: 'All', selected: true},
            {value: '_collection-maia-collection', label: 'Maia Collection'},
            {value: '_collection-greenwich-x-burntaxe-collaboration', label: 'Greenwich x Burntaxe Collaboration'},
            {value: '_collection-pembroke-collection', label: 'Pembroke Collection'},
            {value: '_collection-park-row-collection', label: 'Park Row Collection'}
        ]
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialising...', this)

        for (let imageWrapper of this._elems.imageWrappers) {
            imageWrapper.addEventListener('click', (e) => {
                e.preventDefault()
            })
        }

        for (let select of this._elems.select) {
            if (select.classList.contains('models')) {
                if (this._filterData.brands) {
                    this._filterData.brands.forEach((brand) => {
                        brand.devices.forEach((device) => {
                            let newOption = document.createElement('option')
                            newOption.textContent = device.name
                            newOption.value = device.id
                            select.appendChild(newOption)
                        })
                    })
                }
            }
        }

        this._initChoices(this._vars.pageLoadTags)
    }

    _initChoices (tag) {
        let brandTag
        let modelTag
        let collectionTag

        for (let subtag of tag) {
            if (subtag.includes('brand')) brandTag = subtag
            if (subtag.includes('model')) modelTag = subtag
            if (subtag.includes('collection')) collectionTag = subtag
        }

        if (brandTag === '' || brandTag === undefined) brandTag = '_brand-all'

        this._filters.deviceFilter = new Choices('.collection-filter__model', {
            searchEnabled: false,
            itemSelectText: ''
        })

        this._filters.collectionFilter = new Choices('.collection-filter__collection', {
            searchEnabled: false,
            itemSelectText: ''
        }).setChoices([
            {
                disabled: true,
                choices: this._collectionArray
            }
        ], 'value', 'label', false)

        if (modelTag) this._filters.collectionFilter.destroy()

        window.collectionFilter = this._filters.collectionFilter

        this._filters.sortByFilter = new Choices('.collection-filter__sort-by', {
            searchEnabled: false,
            itemSelectText: ''
        })

        this._onBrandSelect(brandTag, modelTag, collectionTag)

        for (let brandFilter of this._filters.brandFilters) {
            if (brandFilter.previousElementSibling.id === brandTag) {
                this._vars.selectedBrand = brandFilter.previousElementSibling.id
                brandFilter.previousElementSibling.checked = true
            }

            brandFilter.addEventListener('click', () => {
                this._vars.onPageLoaded = true
                this._vars.selectedBrand = brandFilter.previousElementSibling.id
                this._onBrandSelect(this._vars.selectedBrand)
            })
        }

        let filters = document.querySelectorAll('[data-collection-filter]')

        for (let filter of filters) {
            filter.addEventListener('choice', (e) => {
                this._vars.onPageLoaded = true
                // filter the data...
                if (e.detail.choice.value.includes('model')) {
                    this._vars.selectedDevice = e.detail.choice.value
                    this._onDeviceSelect(this._vars.selectedBrand, this._vars.selectedDevice)
                }

                if (this._filters.collectionFilter.choiceList.element.childElementCount > 1) {
                    if (e.detail.choice.value.includes('collection')) {
                        this._vars.selectedCollection = e.detail.choice.value
                        this._onCollectionSelect(this._vars.selectedBrand, this._vars.selectedDevice, this._vars.selectedCollection)
                    }
                }
            })
        }
    }

    _onBrandSelect (brandId, deviceId, collectionId) {
        this._rebuildDevices(brandId, deviceId, collectionId)
        this._rebuildCollections(brandId, deviceId)
        this._buildPath(brandId)
    }

    _onDeviceSelect (brandId, deviceId) {
        this._rebuildCollections(brandId, deviceId)
        this._buildPath(brandId, deviceId)
    }

    _onCollectionSelect (brandId, deviceId, collectionId) {
        this._buildPath(brandId, deviceId, collectionId)
    }

    _rebuildDevices (brandId, deviceId, collectionId) {
        let deviceList = []

        if (brandId) {
            let targetBrand = this._filterData.brands.filter(obj => {
                return obj.id === brandId
            })

            if (targetBrand[0]) {
                for (let device of targetBrand[0].devices) {
                    device.brand_ids.filter(targetBrandId => {
                        if (targetBrandId === brandId && this._vars.currentTags.devices.includes(device.id)) {
                            if (!collectionId) {
                                let obj = {
                                    value: device.id,
                                    label: device.name
                                }
                                deviceList.push(obj)
                            } else {
                                device.collection.filter(collection => {
                                    if (collection.id === collectionId) {
                                        let obj = {
                                            value: device.id,
                                            label: device.name
                                        }
                                        deviceList.push(obj)
                                    }
                                })
                            }
                        }
                    })
                }
            }
        }

        // Reset device list
        let defaultObj = {
            value: 'no-choice',
            label: 'Select Device',
            disabled: true,
            selected: true
        }

        deviceList.push(defaultObj)

        this._filters.deviceFilter.clearChoices()
        this._filters.deviceFilter.setChoices(deviceList, 'value', 'label', true)
        this._filters.deviceFilter.setChoiceByValue(deviceId)
    }

    _rebuildCollections (brandId, deviceId) {
        if (this._filters.collectionFilter._currentState) {
            if (this._filters.collectionFilter._currentState.choices.length > 1) {
                let collectionList = this._collectionArray

                // Reset collection list
                let defaultObj

                defaultObj = {
                    value: 'no-choice',
                    label: 'Select Collection',
                    disabled: true,
                    selected: true
                }

                collectionList.push(defaultObj)

                let selectedCollection

                this._vars.pageLoadTags.forEach((tag) => {
                    if (tag.includes('collection')) {
                        selectedCollection = tag
                    }
                })

                this._filters.collectionFilter.clearChoices()
                this._filters.collectionFilter.setChoices(collectionList, 'value', 'label', true)
                this._filters.collectionFilter.setChoiceByValue(selectedCollection)
            }
        }
    }

    _buildPath (brandId, deviceId, collectionId) {
        let pathArray = [brandId || null, deviceId || null, collectionId || null]

        if (brandId === '_brand-all') pathArray[0] = null
        if (collectionId === '_collection-all') pathArray[2] = null

        let filteredPathArray = pathArray.filter((el) => {
            return el != null
        })

        let newPath = ''

        filteredPathArray.forEach((tag, i) => {
            newPath = newPath + tag
            if (i !== (filteredPathArray.length - 1)) {
                newPath = newPath + '+'
            }
        })

        newPath = this._vars.collectionsPath + newPath + location.search

        if (this._vars.onPageLoaded) window.location.href = newPath
        // console.log(newPath)
    }
}

export default CollectionFilter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionFilter.js